/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountEphemeralCredentialsForGitHubAppProtocol extends models.ServiceAccountEphemeralCredentialsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountEphemeralCredentialsForGitHubAppProtocol");
    }

    getFixupPrototypeFunction() { return ServiceAccountEphemeralCredentialsForGitHubAppProtocol.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountEphemeralCredentialsForGitHubAppProtocol>): ServiceAccountEphemeralCredentialsForGitHubAppProtocol {
        let obj = Object.assign(new ServiceAccountEphemeralCredentialsForGitHubAppProtocol(), model);
        ServiceAccountEphemeralCredentialsForGitHubAppProtocol.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountEphemeralCredentialsForGitHubAppProtocol>): ServiceAccountEphemeralCredentialsForGitHubAppProtocol {
        if (!model) return null;
        return ServiceAccountEphemeralCredentialsForGitHubAppProtocol.newInstance(<ServiceAccountEphemeralCredentialsForGitHubAppProtocol> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountEphemeralCredentialsForGitHubAppProtocol) {
        if (!obj) return;

        models.ServiceAccountEphemeralCredentialsForGitHubAppProtocol.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountEphemeralCredentialsForGitHubAppProtocol): boolean {
        if (models.ServiceAccountEphemeralCredentialsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountEphemeralCredentialsForGitHubAppProtocol.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Authorization Token
     */
    authorization_token: string;

}
